import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import { UserProps, AuthOProps } from '../../../shared/prop-types/ReducerProps';
import { hookAuth0 } from '../../../shared/components/auth/withAuth0';
import { auth } from '../../../redux/actions/authActions';
import TopbarMenuLink from './TopbarMenuLink';

const auth0Icon = 'https://icon-library.com/images/default-user-icon/default-user-icon-18.jpg';

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

const TopbarProfile = ({ auth0, user }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const dispatch = useDispatch();

  const toggleProfile = () => {
    setIsCollapsed(!isCollapsed);
  };

  const logout = () => {
    localStorage.removeItem('easydev');
  };

  useEffect(() => {
    const userStored = localStorage.getItem('easydev-user')
    if (userStored) {
      dispatch(auth({
        name: userStored,
        avatar: auth0Icon,
      }));
    }
  }, [])
  console.log(user)
  console.log(user.name)
  console.log(user.fullName)
  return (
    <div className="topbar__profile">
      <button className="topbar__avatar" type="button" onClick={toggleProfile}>
        <img
          className="topbar__avatar-img"
          src={(auth0?.user && auth0?.user?.picture) || (user && user?.avatar) || Ava}
          alt="avatar"
        />
        <p className="topbar__avatar-name">
          {(auth0?.user && auth0?.user?.name) || (user && user?.fullName)}
          {/* {auth0.loading ? 'Loading...' : (auth0.user && auth0.user.name) || (user && user.fullName)} */}
        </p>
        <DownIcon className="topbar__icon" />
      </button>
      {isCollapsed && (
        <button
          className="topbar__back"
          type="button"
          aria-label="profile button"
          onClick={toggleProfile}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
          {/* <TopbarMenuLink
            title="My Profile"
            icon="user"
            path="/account/profile"
            onClick={toggleProfile}
          />
          <TopbarMenuLink
            title="Calendar"
            icon="calendar-full"
            path="/default_pages/calendar"
            onClick={toggleProfile}
          />
          <TopbarMenuLink
            title="Tasks"
            icon="list"
            path="/todo"
            onClick={toggleProfile}
          />
          <TopbarMenuLink
            title="Inbox"
            icon="inbox"
            path="/mail"
            onClick={toggleProfile}
          />
          <div className="topbar__menu-divider" />
          <TopbarMenuLink
            title="Account Settings"
            icon="cog"
            path="/account/profile"
            onClick={toggleProfile}
          />
          <TopbarMenuLink
            title="Lock Screen"
            icon="lock"
            path="/lock_screen"
            onClick={toggleProfile}
          /> */}

          {auth0.isAuthenticated && (
            <TopbarMenuLink
              title="Log Out Auth0"
              icon="exit"
              path="/login"
              onClick={auth0.logout}
            />
          )}
          {user?.fullName === 'sam@getrael.com' && (
            <TopbarMenuLink
              title="Show DB Query"
              icon="book"
              path="/query"
            />)}
          {user?.fullName === 'sam@getrael.com' && (
            <TopbarMenuLink
              title="Data Ingestion"
              icon="book"
              path="/data-ingestion-batch-status"
            />)}
          <TopbarMenuLink
            title="Log Out"
            icon="exit"
            path="/login"
            onClick={logout}
          />
        </div>
      </Collapse>
    </div>
  );
};

TopbarProfile.propTypes = {
  user: UserProps,
  auth0: AuthOProps.isRequired,
};

TopbarProfile.defaultProps = {
  user: {},
};

export default hookAuth0(TopbarProfile);
